module.exports = __webpack_public_path__ + "static/media/curve-6.b9e8fd8b.svg";